module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.c70901af.woff";